import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SignupProgressDataService {

  logs = {};
  logsKey = [];
  constructor() { }

  clearData() {
    this.logs = {};
    this.logsKey = [];
  }

  addMessageObject(message) {
    this.onMessageReceived(message, false);
  }

  addMessage(title, message = {icon: '', type: '', info: ''}) {
    this.onMessageReceived({
      title: title,
      message: message
    }, false);

  }

  onMessageReceived(response, queryData) {

    let temp: any;
    let index: number;

    if (response.hasOwnProperty('title')) {
      temp = response['title'].split(' ');
      temp = temp.join('_');
    }

    if (!(this.logs.hasOwnProperty(response['title']))) {
      // this.selectedIndex++;
      this.logsKey.push({
        name: response['title'],
        icon: response['message']['icon'],
        classname: temp
      });
      if (response['title'] !== 'DONE') {
        this.logs[response['title']] = [];
      }
    }

    if (this.logs[response['title']]) {
      index = this.logs[response['title']].findIndex(value => value['info'] === response['message']['info']);
    } else {
      index = -1;
    }
    switch (response['message']['type']) {
      case 'error':
        let className = response['message']['info'].replace(/<[^>]*>/g, '').replace(/[^a-zA-Z ]/g, '').split(' ');
        className = className.join('_');
        const headerPayload = [{key: 'Content-Type', value: 'application/json', description: '', req: false}];
        if (response['message']['apikey']) {
          headerPayload.push({key: 'apikey', value: response['message']['headers']['apikey'], description: '', req: false});
        }
        if (response['message']['pkey']) {
          headerPayload.push({key: 'pkey', value: response['message']['headers']['pkey'], description: '', req: false});
        }
        if (index !== -1) {
          this.logs[response['title']][index]['status'] = 'failed';
        } else {
          const obj = {
            info: response['message']['info'],
            status: 'failed'
          };
          this.logs[response['title']].push(obj);
        }
        break;
      case 'fatal':
        let description: any;
        if (response['message']['description'] && response['message']['description'] !== undefined) {
          description = response['message']['description'];
        } else {
          description = response['message']['info'];
        }
        const fatalPayload = {
          title: response['title'],
          className: response['message']['info'].replace(/<[^>]*>/g, '').replace(/[^a-zA-Z ]/g, '').split(' ').join('_'),
          type: 'Fatal'
        };
        fatalPayload['description'] = response['message']['description'] ? response['message']['description'].toString() : '';
        if (index !== -1) {
          this.logs[response['title']][index]['status'] = 'failed';
        } else {
          const obj = {
            info: response['message']['info'],
            status: 'failed'
          };
          this.logs[response['title']].push(obj);
        }
        break;
      case 'retry':
        if (index !== -1) {
          this.logs[response['title']][index]['status'] = 'initial';
        } else {
          const obj = {
            info: response['message']['info'],
            status: 'initial'
          };
          this.logs[response['title']].push(obj);
        }
        break;
      case 'initial':
        if (!queryData) {
          if (index === -1) {
            const obj = {
              info: response['message']['info'],
              status: 'initial'
            };
            this.logs[response['title']].push(obj);
          }
        }
        break;
      case 'success':
        if (index !== -1) {
          this.logs[response['title']][index]['status'] = 'success';
          this.logs[response['title']][index]['messageType'] = response['message']['messageType'];
          this.logs[response['title']][index]['description'] = response['message']['description'];
          this.logs[response['title']][index]['data'] = response['message']['data'];
        } else {
          if (response['title'] !== 'DONE') {
            const obj = {
              info: response['message']['info'],
              status: 'success',
              messageType: response['message']['messageType'],
              description: response['message']['description'],
              data: response['message']['data'],
            };
            this.logs[response['title']].push(obj);
          }
        }
        break;
      case 'warning':
        if (index !== -1) {
          this.logs[response['title']][index]['status'] = 'warning';
          this.logs[response['title']][index]['messageType'] = response['message']['messageType'];
          this.logs[response['title']][index]['description'] = response['message']['description'];
          this.logs[response['title']][index]['data'] = response['message']['data'];
        } else {
          if (response['title'] !== 'DONE') {
            const obj = {
              info: response['message']['info'],
              status: 'warning',
              messageType: response['message']['messageType'],
              description: response['message']['description'],
              data: response['message']['data'],
            };
            this.logs[response['title']].push(obj);
          }
        }
        break;
      case 'warning-low':
        if (index !== -1) {
          this.logs[response['title']][index]['status'] = 'warning-low';
          this.logs[response['title']][index]['messageType'] = response['message']['messageType'];
          this.logs[response['title']][index]['description'] = response['message']['description'];
          this.logs[response['title']][index]['data'] = response['message']['data'];
        } else {
          if (response['title'] !== 'DONE') {
            const obj = {
              info: response['message']['info'],
              status: 'warning-low',
              messageType: response['message']['messageType'],
              description: response['message']['description'],
              data: response['message']['data'],
            };
            this.logs[response['title']].push(obj);
          }
        }
        break;
      case 'initialforquery':
        if (index === -1) {
          const obj = {
            info: response['message']['info'],
            status: 'initial'
          };
          this.logs[response['title']].push(obj);
        }
        break;
      default:
        break;
    }
  }
}
